module.exports = __webpack_public_path__ + "static/media/icon-google.1b943d72.png";